<template>
    <div id="contract_billing_frequency_create" class="fleet-form-main">
        <div :class="`loader${loaderClass}`" v-show="loading">
            
        </div>
        <div id="page-content-wrapper" class="admin-content-area">
            <template v-if="cantAccessPage === true">
                <div class="container-fluid xyz">
                    <div class="page-name">
                        <span id="contractBillingFrequencyHeader" v-if="$route.params.id > 0">Update Contract Billing Frequency</span>
                        <span id="contractBillingFrequencyHeader" v-else>Add Contract Billing Frequency</span>
                        <button type="submit" class="btn btn-success waves-effect pull-right back-btn-fl" v-on:click.prevent="BackContractBillingFrequencyList" >
                               <i class="hi-icon icon-flback"> </i> Back
                        </button>
                    </div>
                    <div class="admin-page-content">
                        <section class="internal-container border-top-table-fl">
                            <div class="container">
                                <form autocomplete="off" class="form-horizontal basic-form-container form-custom-select" id="ContractBillingFrequencyForm">
                                    <div class="col-md-12">
                                        <div class="form-group">
                                           <div class="row"> 
                                            <div class="col-xs-12 col-sm-6 col-md-6 col-lg-6">
                                                <label class="control-label required" for="name">Name:</label>
                                                <input type="text" class="form-control" v-model="name" id="name" placeholder="Enter Name" name="name">
                                                <div class="c-error">{{name_error_msg}}</div>
                                            </div>

                                            <div class="col-xs-12 col-sm-2 col-md-2 col-lg-2">
                                                <label class="control-label required" for="code">Code:</label>
                                                <input type="text" class="form-control" v-model="code" id="code" placeholder="Enter Code" name="code">
                                                <div class="c-error">{{code_error_msg}}</div>
                                            </div>
                                        
                                            <div class="alert alert-warning hide col-sm-offset-2 col-sm-6" id="alertError">
                                                <button type="button" class="close" data-dismiss="alert" aria-label="Close"><span aria-hidden="true">&times;</span></button>
                                                <strong id="errorMsg" class="error"></strong>
                                            </div>
                                           </div>
                                        </div>
                                    </div>

                                    <!-- <div class="form-group"> -->
                                    <div class="col-sm-12 btm-action-btn-fl">
                                        <div class="row">

                                            <button type="submit" id="createContractBillingFrequencyBtn" v-if="$route.params.id > 0" class="btn btn-primary nextBtn btn-lg pull-left" v-on:click.prevent="CreateContractBillingFrequency" >
                                                <i class="hi-icon icon-flUpdate-data"> </i>  Update
                                            </button>

                                            <button type="submit" id="createContractBillingFrequencyBtn" v-else class="btn btn-primary nextBtn btn-lg pull-left" v-on:click.prevent="CreateContractBillingFrequency" >
                                                <i class="hi-icon icon-flSave"> </i>  Save
                                            </button>
                                            
                                            <button type="submit" id="createAndContinueContractBillingFrequencyBtn" v-if="$route.params.id == undefined" class="btn btn-primary nextBtn btn-lg pull-left save-continue-btn" v-on:click.prevent="CreateContractBillingFrequency(flag='Save and Continue')" >
                                                <i class="hi-icon icon-flSave-Continue"> </i>  Save and Continue
                                            </button>

                                            <button type="submit" id="cancelContractBillingFrequencyBtn" class="btn btn-primary nextBtn btn-lg pull-left cancel-btn" v-on:click.prevent="BackContractBillingFrequencyList" >
                                                <i class="hi-icon icon-flCancel"> </i>  Cancel
                                            </button>
                                                 
                                        </div>
                                    </div>
                                    <!-- </div> -->

                                </form>
                            </div>
                        </section>    
                    </div>
                </div>
            </template>
            <template v-else-if="cantAccessPage === false">
                <div class="col-md-12">
                    <div class="error-template">
                        <h1>
                            Oops!</h1>
                        <h2>
                            403 </h2>
                        <div class="error-details">
                            Sorry!, You don't have permission to access this page.
                        </div>
                    </div>
                </div>
            </template>
            <template v-else>
                <loading-content></loading-content>
            </template>
            <app-footer></app-footer>
        </div>

    </div>
</template>
<script>
import Vue from "vue";

import {commonMixins} from '../mixins/commonMixins';


export default {
  name: "ContractBillingFrequencyCreate",
  
  mixins:[commonMixins],
  data: () => ({
    permissions: [],
    cantAccessPage: "",
    name: "",
    code: "",
    loading:false,
    name_error_msg: "",
    code_error_msg: ""
  }),
  watch:{

        //check permission change
        permissions: function (permissions) {
            var self = this;
            if (permissions.length > 0) {
                for (var i = 0; i < permissions.length; i++) {
                    if (permissions[i].name == 'add_contract_billing_frequency') {
                        self.cantAccessPage = true;
                    }
                }
            }

        }

  },
  created: function() {

  },
  mounted: function() {
        var self = this;
        self.getPermissions();
        var path = window.location.pathname;
        var segments = path.split("/");
        
        if (segments[3]) {
            self.loadContractBillingFrequency();
        }
  },
  methods: {

    BackContractBillingFrequencyList() {
      var self = this;
      self.$router.push("/contractbillingfrequency/list");
    },

    CreateContractBillingFrequency(flag) {
        var self = this;

        self.code = self.code.trim();
        self.name = self.name.trim();

        self.name_error_msg = "";
        self.code_error_msg = "";

        if (!self.name || self.name == null || self.name == "") {
            self.name_error_msg = "Name Required.";
        }

        if (!self.code || self.code == null || self.code == "") {
            self.code_error_msg = "Code Required.";
        }

        if (self.name_error_msg == "" && self.code_error_msg == "") {

            self.loading = true;
            var path = window.location.pathname;
            var segments = path.split("/");
            if (segments[3])
            {
                $("#createContractBillingFrequencyBtn").val("Updating ...");
                $("#createContractBillingFrequencyBtn").prop("disabled", true);
                $("#cancelContractBillingFrequencyBtn").prop("disabled",true);
            } else {
                if (flag == "Save and Continue") {

                    $("#createAndContinueContractBillingFrequencyBtn").val("Saving ...");
                    $("#createContractBillingFrequencyBtn").prop("disabled", true);
                    $("#createAndContinueContractBillingFrequencyBtn").prop("disabled", true);
                    $("#cancelContractBillingFrequencyBtn").prop("disabled",true);

                }else{

                    $("#createContractBillingFrequencyBtn").val("Saving ...");
                    $("#createContractBillingFrequencyBtn").prop("disabled", true);
                    $("#createAndContinueContractBillingFrequencyBtn").prop("disabled", true);
                    $("#cancelContractBillingFrequencyBtn").prop("disabled",true);
                }
               
            }
            
            $.ajax({
                url: process.env.ROOT_API + "/contractbillingfrequency/create",
                type: "POST",
                data: {name: self.name,id: segments[3], code: self.code},
                headers: this.ajxHeaders,
                dataType: "json",
                success: function (data) {
                    self.loading = false;
                    if (segments[3])
                    {
                        $("#createContractBillingFrequencyBtn").val("Update");
                        $("#createContractBillingFrequencyBtn").prop("disabled", false);
                        $("#cancelContractBillingFrequencyBtn").prop("disabled",false);
                    } else {
                        if (flag == "Save and Continue") {

                            $("#createAndContinueContractBillingFrequencyBtn").val("Save and Continue");
                            $("#createContractBillingFrequencyBtn").prop("disabled", false);
                            $("#createAndContinueContractBillingFrequencyBtn").prop("disabled", false);
                            $("#cancelContractBillingFrequencyBtn").prop("disabled",false);

                        }else{

                            $("#createContractBillingFrequencyBtn").val("Save");
                            $("#createContractBillingFrequencyBtn").prop("disabled", false);
                            $("#createAndContinueContractBillingFrequencyBtn").prop("disabled", false);
                            $("#cancelContractBillingFrequencyBtn").prop("disabled",false);

                        }
                    }
                    if (data.status == "success") {

                        if (flag == "Save and Continue") {

                            self.name = "";
                            self.code = "";

                        }else{
                            self.$router.push("/contractbillingfrequency/list");
                        }
                        
                    } else {
                        if (data.content.length > 0) {
                            var err = "";
                            for (var i = 0; i < data.content.length; i++) {
                                err += data.content[i] + "<br>";
                            }
                            $("#errorMsg").html(err);
                            $(".alert-warning").toggleClass("show");
                            setTimeout(function () {
                                $(".alert-warning").removeClass("show");
                                $(".alert-warning").addClass("hide");
                            }, 10000);
                        }
                    }
                },
                error: function (jqXHR, exception) {
                    self.loading = false;
                    if (segments[3])
                    {
                        $("#createContractBillingFrequencyBtn").val("Update");
                        $("#createContractBillingFrequencyBtn").prop("disabled", false);
                        $("#cancelContractBillingFrequencyBtn").prop("disabled",false);
                    } else {
                        if (flag == "Save and Continue") {
                            
                            $("#createAndContinueContractBillingFrequencyBtn").val("Save and Continue");
                            $("#createContractBillingFrequencyBtn").prop("disabled", false);
                            $("#createAndContinueContractBillingFrequencyBtn").prop("disabled", false);
                            $("#cancelContractBillingFrequencyBtn").prop("disabled",false);

                        }else{

                            $("#createContractBillingFrequencyBtn").val("Save");
                            $("#createContractBillingFrequencyBtn").prop("disabled", false);
                            $("#createAndContinueContractBillingFrequencyBtn").prop("disabled", false);
                            $("#cancelContractBillingFrequencyBtn").prop("disabled",false);

                        }
                    }
                    self.generateStatusCodeMessage(jqXHR,true,'contract-billing-frequency-create')
                }
            });
        }
    },

    loadContractBillingFrequency() {
        var path = window.location.pathname;
        var segments = path.split("/");
        var self = this;
        self.loading = true;
        $.ajax({
            url: process.env.ROOT_API + "/contractbillingfrequency/" + segments[3],
            type: "GET",
            headers: this.ajxHeaders,
            dataType: "json",
            success: function (data) {
                self.loading = false;
                if (data.status == "success") {
                    self.name = data.content.name;
                    self.code = data.content.code;
                } 
            },
            error: function (jqXHR, exception) {
                self.loading = false;
                self.generateStatusCodeMessage(jqXHR,false,'get-contract-billing-frequency-by-id')
            }
        });
    },
  }
};
</script>   


// WEBPACK FOOTER //
// src/components/ContractBillingFrequencyCreate.vue